import { BASE_URL } from "../../config";
import { SET_ERROR_STATE, REQ_NEGOSIASI, REQ_NEGOSIASI_DONE, SET_SUCCESS_NEGOSIASI } from "../../utils/constants/actionTypes";
import { URjtNego, UAccNego, SNego, UAccNegoV2 } from "../../config/api";
import bugsnagClient from "../../config/bugsnag";

export const RejectNego = (ClientID, loanCode, memo, cb) => async (dispatch) => {
	dispatch({ type: REQ_NEGOSIASI });
	try {
		let res = await fetch(`${BASE_URL}${URjtNego(loanCode)}`, {
			method: "POST",
			credentials: "include",
			headers: {
				"X-Client-ID": ClientID,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ loan: { memo } }),
		});
		let hasil = await res.json();
		if (res.status === 200) {
			dispatch({ type: SET_SUCCESS_NEGOSIASI });
			cb(true);
		} else if (res.status === 500) {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.code + " - " + hasil.status.message });
			dispatch({ type: REQ_NEGOSIASI_DONE });
			bugsnagClient.notify(new Error(`Negosiasi.js/RejectNego (line 27) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
			cb(false);
		} else {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });
			dispatch({ type: REQ_NEGOSIASI_DONE });
			bugsnagClient.notify(new Error(`Negosiasi.js/RejectNego (line 32) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
			cb(false);
		}
	} catch (err) {
		dispatch({ type: SET_ERROR_STATE, payload: err.message });
		dispatch({ type: REQ_NEGOSIASI_DONE });
		bugsnagClient.notify(new Error(`Negosiasi.js/RejectNego (line 38) ===> catch - ${err.message}`));
		cb(false);
	}
};
export const AccNego = (ClientID, loanCode, memo, cb) => async (dispatch) => {
	dispatch({ type: REQ_NEGOSIASI });
	try {
		let res = await fetch(`${BASE_URL}${UAccNego(loanCode)}`, {
			method: "POST",
			credentials: "include",
			headers: {
				"X-Client-ID": ClientID,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ loan: { memo } }),
		});
		let hasil = await res.json();
		if (res.status === 200) {
			dispatch({ type: SET_SUCCESS_NEGOSIASI });
			cb(true);
		} else if (res.status === 500) {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.code + " - " + hasil.status.message });
			dispatch({ type: REQ_NEGOSIASI_DONE });
			bugsnagClient.notify(new Error(`Negosiasi.js/AccNego (line 62) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
			cb(false);
		} else {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });
			dispatch({ type: REQ_NEGOSIASI_DONE });
			bugsnagClient.notify(new Error(`Negosiasi.js/AccNego (line 67) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
			cb(false);
		}
	} catch (err) {
		dispatch({ type: SET_ERROR_STATE, payload: err.message });
		dispatch({ type: REQ_NEGOSIASI_DONE });
		bugsnagClient.notify(new Error(`Negosiasi.js/AccNego (line 73) ===> catch - ${err.message}`));
		cb(false);
	}
};
export const Negotiate = (ClientID, loanCode, data, cb) => async (dispatch) => {
	dispatch({ type: REQ_NEGOSIASI });
	try {
		let res = await fetch(`${BASE_URL}${SNego(loanCode)}`, {
			method: "POST",
			credentials: "include",
			headers: {
				"X-Client-ID": ClientID,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ loan: data }),
		});
		let hasil = await res.json();
		if (res.status === 200) {
			dispatch({ type: SET_SUCCESS_NEGOSIASI });
			cb(true);
		} else if (res.status === 500) {
			dispatch({ SET_ERROR_STATE, payload: hasil.status.code + " - " + hasil.status.message });
			dispatch({ type: REQ_NEGOSIASI_DONE });
			bugsnagClient.notify(new Error(`Negosiasi.js/Negotiate (line 96) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
			cb(false);
		} else {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });
			dispatch({ type: REQ_NEGOSIASI_DONE });
			bugsnagClient.notify(new Error(`Negosiasi.js/Negotiate (line 101) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
			cb(false);
		}
	} catch (err) {
		dispatch({ type: SET_ERROR_STATE, payload: err.message });
		dispatch({ type: REQ_NEGOSIASI_DONE });
		bugsnagClient.notify(new Error(`Negosiasi.js/Negotiate (line 107) ===> catch - ${err.message}`));
		cb(false);
	}
};
export const AccNegoV2 = (ClientID, loanCode, memo, cb) => async (dispatch) => {
	dispatch({ type: REQ_NEGOSIASI });
	try {
		let res = await fetch(`${BASE_URL}${UAccNegoV2(loanCode)}`, {
			method: "POST",
			credentials: "include",
			headers: {
				"X-Client-ID": ClientID,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ memo }),
		});
		let hasil = await res.json();
		if (res.status === 200) {
			dispatch({ type: SET_SUCCESS_NEGOSIASI });
			cb(true);
		} else if (res.status === 500) {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.code + " - " + hasil.status.message });
			dispatch({ type: REQ_NEGOSIASI_DONE });
			bugsnagClient.notify(new Error(`Negosiasi.js/AccNego (line 130) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
			cb(false);
		} else {
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });
			dispatch({ type: REQ_NEGOSIASI_DONE });
			bugsnagClient.notify(new Error(`Negosiasi.js/AccNego (line 135) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
			cb(false);
		}
	} catch (err) {
		dispatch({ type: SET_ERROR_STATE, payload: err.message });
		dispatch({ type: REQ_NEGOSIASI_DONE });
		bugsnagClient.notify(new Error(`Negosiasi.js/AccNego (line 141) ===> catch - ${err.message}`));
		cb(false);
	}
};
